import { makeStyles, withStyles } from '@mui/styles'
import HelpIcon from '@mui/icons-material/Help'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { editDriver } from '../actions/t4aActions'
import { showAlertSnackbar } from '../reducers/sliceReducer'
import FullscreenLoading from './FullscreenLoading'

const FixedTextField = withStyles(theme => ({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: '10px !important'
    },
    width: 360,
    marginTop: 8
  }
}))(TextField)
const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 17,
    fontWeight: 'bold',
    color: '#262626',
    marginTop: 34,
    marginLeft: 20
  },
  description: {
    fontSize: 14,
    color: '#262626',
    marginTop: 23,
    marginLeft: 20
  },
  descriptionInfo: {
    fontWeight: 'bold'
  },
  info: {
    backgroundColor: '#fff4ea',
    marginTop: 18,
    paddingTop: 15,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 37
  },
  infoTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#262626'
  },
  infoName: {
    fontSize: 14,
    color: '#636463',
    marginTop: 17,
    width: 305,
    fontWeight: 'normal'
  },
  buttonStyle: {
    width: '100%',
    textAlign: 'center',
    marginTop: 24
  },
  confirm: {
    width: 250,
    marginTop: 45,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  buttonGroup: {
    width: '100%',
    textAlign: 'center',
    marginTop: 24,
    display: 'flex',
    justifyContent: 'space-between'
  }
}))

function T4A() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const driverInfo = useSelector(state => state.t4a.searchDriver)

  const [descriptionOpen, setDescriptionOpen] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [lastName, setLastName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [address, setAddress] = useState('')
  const [insurance, setInsurance] = useState('')
  const [amount, setAmount] = useState('')
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState()

  const init = useCallback(driverInfo => {
    setLastName(driverInfo.last_name)
    setFirstName(driverInfo.first_name)
    setAddress(driverInfo.address)
    setInsurance(driverInfo.sin)
    setAmount(driverInfo.amount)
    setId(driverInfo.id)
  }, [])

  function handleDescriptionClose(event, reason) {
    if (reason === 'clickaway') {
      return
    }
    setDescriptionOpen(false)
  }
  function handleEdit() {
    setLoading(true)
    let params = {
      last_name: lastName,
      first_name: firstName,
      address: address,
      sin: insurance
    }
    dispatch(editDriver(id, params))
      .then(() => {
        setLoading(false)
        setDisabled(true)
        dispatch(
          showAlertSnackbar({
            message: 'Upload information successfully!',
            type: 'success'
          })
        )
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showAlertSnackbar({
            message: 'Failed to upload information, please contact manager!',
            type: 'error'
          })
        )
      })
  }
  function handleConfirm() {
    setLoading(true)
    let params = {
      confirmed: 1
    }
    dispatch(editDriver(id, params))
      .then(() => {
        setLoading(false)
        history.push('t4a-download')
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showAlertSnackbar({
            message: 'Failed to upload confirm status, please contact manager!',
            type: 'error'
          })
        )
      })
  }

  useEffect(() => {
    setDisabled(true)
  }, [])
  useEffect(() => {
    if (driverInfo) {
      init(driverInfo)
    }
  }, [driverInfo, init])
  useEffect(() => {
    if (!window.localStorage.getItem('token')) {
      history.push('/t4a-login')
    }
  }, [history])

  return (
    <div style={{ paddingBottom: 40 }}>
      <Snackbar
        open={descriptionOpen}
        autoHideDuration={10000}
        onClose={handleDescriptionClose}>
        <Alert
          onClose={handleDescriptionClose}
          variant='filled'
          severity='info'
          style={{ color: 'white' }}>
          Contact your driver manager if there is any discrepancy in your total
          uniuni income. Contactez votre gestionnaire de chauffeur s'il y a une
          différence dans votre revenu uniuni total.
        </Alert>
      </Snackbar>
      <img
        src='/images/group-copy.svg'
        alt=''
        style={{
          height: 42,
          width: 178,
          marginTop: 22,
          marginLeft: 20
        }}
      />
      <div className={classes.title}>Review Your T4A / Révisez votre T4A</div>
      <div className={classes.description}>
        <div>
          Payer's name / Nom du payeur:{' '}
          <span className={classes.descriptionInfo}>{driverInfo.company}</span>
        </div>
        <div>
          Year / Annéé:{' '}
          <span className={classes.descriptionInfo}>{driverInfo.year}</span>
        </div>
      </div>
      <div className={classes.info}>
        <div className={classes.infoTitle}>
          <div>Recipient’s information</div>
          <div>Informations sur le destinataire :</div>
        </div>
        <div>
          <div className={classes.infoName}>Last name / Nom de famille</div>
          <FixedTextField
            variant='outlined'
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div>
          <div className={classes.infoName}>First name / Prénom</div>
          <FixedTextField
            variant='outlined'
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div>
          <div className={classes.infoName}>Address / Adresse</div>
          <FixedTextField
            variant='outlined'
            value={address}
            onChange={e => setAddress(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div>
          <div className={classes.infoName}>
            Social insurance number / Numéro d'assurance sociale
          </div>
          <FixedTextField
            variant='outlined'
            value={insurance}
            onChange={e => setInsurance(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div>
          <div className={classes.infoName}>
            Fees for services / Honoraires ou autres sommes pour services rendus
          </div>
          <FixedTextField
            variant='outlined'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <HelpIcon
                    style={{ color: '#8a8b8a' }}
                    onClick={() => setDescriptionOpen(true)}
                  />
                </InputAdornment>
              )
            }}
            disabled
            value={amount}
          />
        </div>
        {/* {disabled && (
          <div className={classes.buttonStyle}>
            <Button
              onClick={() => {
                setDisabled(false)
              }}
              variant='outlined'
              sx={{ width: 194, height: 34 }}>
              Edit / Éditer
            </Button>
          </div>
        )} */}
        {!disabled && (
          <div className={classes.buttonGroup}>
            <Button
              onClick={() => {
                init(driverInfo)
                setDisabled(true)
              }}
              variant='outlined'
              sx={{ height: 34 }}>
              Cancel / Annuler
            </Button>
            <Button
              onClick={() => {
                setDisabled(true)
                handleEdit()
              }}
              variant='contained'
              color='secondary'
              sx={{ height: 34 }}>
              Save / Sauver
            </Button>
          </div>
        )}
      </div>
      <div className={classes.confirm}>
        <Button
          onClick={handleConfirm}
          disabled={!disabled}
          variant='contained'
          color='secondary'
          sx={{ width: 250, height: 40 }}>
          Confirm / Confirmer
        </Button>
      </div>
      <div
        style={{
          marginTop: 10,
          width: 300,
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center'
        }}>
        Please confirm your information before February 28, 2026. / Veuillez
        confirmer vos informations avant le 28 février 2026.
      </div>
      <FullscreenLoading open={loading} />
    </div>
  )
}

export default T4A
